import { Injectable, inject } from '@angular/core';
import { AlphaHttpClient } from './alpha-http-client';

@Injectable({ providedIn: 'root' })
export class TenantService {
    private httpClient = inject(AlphaHttpClient);

    private domainUrl = {
        type: 'environment',
        value: {
            __alpha_env__: 'ALPHA_UI_CONFIG_SERVICE_URL',
        },
    };

    saveTenant(tenant: string) {
        return this.httpClient.post(this.domainUrl, '/tenant/create', { name: tenant }).pipe((r) => {
            sessionStorage.setItem('tenant', tenant);
            return r;
        });
    }

    fetchTenant() {
        return sessionStorage.getItem('tenant');
    }
}
